import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import classNames from "classnames";
import styles from "./HoverInfoWrapper.less";
const HoverInfoWrapper = (props) => {
    const { tipText, className, tipPosition } = props;
    const popover = (React.createElement(Tooltip, { id: tipText }, tipText));
    return (React.createElement(OverlayTrigger, { placement: tipPosition, overlay: popover },
        React.createElement("div", { className: classNames(styles.container, className) }, props.children)));
};
HoverInfoWrapper.defaultProps = {
    tipPosition: "top",
    className: "",
};
export default HoverInfoWrapper;
